export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-scale/src/constant.js
// module id = BCA1
// module chunks = 0